<template>
  <div class="chromatography">
    <b-row
      v-if="shouldShowPendingLotsAmount"
      align-h="center"
      class="chromatography__pending-lots-warning-wrapper"
    >
      <b-alert
        variant="warning"
        class="chromatography__pending-lots-warning"
        show
        v-html="pendingAmountMessage"
      />
    </b-row>
    <base-panel
      :asset="asset"
      :asset-module="assetModule"
      :asset-type="assetType"
      :tabs="tabs"
      :asset-general-info="assetGeneralInfo"
      :hide-print-button="false"
      :notifications="notifications"
      @change-pending-lots="assignAmountOfPendingLots"
    />
  </div>
</template>

<script>
import tabNames from '@/domain/enums/installation/engineering/chromatography/chromatographyTabs';
import BasePanel from '@/domain/components/installation/engineering/BasePanel';
import AlarmLevelParameters from '@/domain/components/installation/engineering/chromatography/alarmLevelParameters/index';
import General from '@/domain/components/installation/engineering/chromatography/general/index';
import InsertSample from '@/domain/components/installation/engineering/chromatography/insertSample';
import MethodsParameters from '@/domain/components/installation/engineering/chromatography/methodsParameters';

export default {
  components: {
    BasePanel,
  },
  props: {
    asset: Object,
    assetType: Object,
    assetModule: Object,
    assetGeneralInfo: Object,
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    amountOfPendingLots: 0,
  }),
  computed: {
    sampleTabTitle() {
      return this.$route.query.sampleId
        ? 'engineering.chromatography.tab-name.edit-sample'
        : 'engineering.chromatography.tab-name.insert-sample';
    },
    tabs() {
      return [
        {
          name: tabNames.GENERAL,
          title: this.$t('engineering.chromatography.tab-name.general'),
          component: General,
        },
        {
          name: tabNames.SAMPLE,
          title: this.$t(this.sampleTabTitle),
          component: InsertSample,
        },
        {
          name: tabNames.METHOD_PARAMETERS,
          title: this.$t('engineering.chromatography.tab-name.method-parameters'),
          component: MethodsParameters,
        },
        {
          name: tabNames.ALARM_LEVEL_PARAMETERS,
          title: this.$t('engineering.chromatography.tab-name.alarm-level-parameters'),
          component: AlarmLevelParameters,
        },
      ];
    },
    pendingAmountMessage() {
      return this.$t('engineering.chromatography.general.pending-lots-alert', {
        amountOfPendingLots: this.amountOfPendingLots,
      });
    },
    shouldShowPendingLotsAmount() {
      return this.amountOfPendingLots > 0;
    },
  },
  methods: {
    assignAmountOfPendingLots(amount) {
      this.amountOfPendingLots = amount;
    },
  },
};
</script>
<style lang="sass" scoped>
  .chromatography
    &__pending-lots-warning-wrapper
      position: relative
    &__pending-lots-warning
      position: absolute
      top: -80px
      width: 95%
      text-align: center
      z-index: 1
</style>
